/**
 * RitualInfoSection Component
 * Displays ritual title and description in the left column
 */

import { useIsMobile } from "@/hooks/useIsMobile"
import type { RitualButtonState } from "../../pages/ritualDetail"
import type { RitualDetailData } from "../../types/detail.types"
import { RitualActionCard } from "./RitualSidebar"

interface RitualInfoSectionProps {
  title: string
  description: string
  ritualData: RitualDetailData
  buttonState: RitualButtonState
  onActionSuccess?: () => void
  isGuest?: boolean
}

export function RitualInfoSection({
  title,
  description,
  buttonState,
  ritualData,
  onActionSuccess,
  isGuest = false,
}: RitualInfoSectionProps) {
  const isMobile = useIsMobile()
  return (
    <div className="md:space-y-5">
      <h1 className="section-heading text-primary text-lg md:text-[28px] leading-6.25 md:leading-11.25 font-semibold pb-2.5 md:pb-0">
        {title}
      </h1>

      {isMobile && (
        <RitualActionCard
          data={ritualData}
          buttonState={buttonState}
          onActionSuccess={onActionSuccess}
          isGuest={isGuest}
        />
      )}
      <p className="text-[#F2F0EBE6] text-sm leading-5.5 md:leading-7.5 mt-7.5 md:mt-0">
        {description}
      </p>
    </div>
  )
}
